var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInlineAlert = function SvgInlineAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inline-alert",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_7",
    "data-name": "Polygon 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M6.1,2,2,6.1v5.8L6.1,16h5.8L16,11.9V6.1L11.9,2H6.1M5.686,1h6.628L17,5.686v6.628L12.314,17H5.686L1,12.314V5.686Z",
    fill: "#241c15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M10.13,9.2l2.224-2.224a.5.5,0,0,0,0-.706l-.424-.423a.5.5,0,0,0-.706,0L9,8.068,6.776,5.844a.5.5,0,0,0-.706,0l-.424.423a.5.5,0,0,0,0,.706L7.87,9.2,5.646,11.421a.5.5,0,0,0,0,.707l.424.423a.5.5,0,0,0,.706,0L9,10.327l2.224,2.224a.5.5,0,0,0,.706,0l.424-.423a.5.5,0,0,0,0-.707Z",
    fill: "#241c15"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInlineAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inline-alert.a99769ab.svg";
export { ForwardRef as ReactComponent };